import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsString, ValidateNested } from "class-validator";

export class NotSettledDocumentAmount {
  @Expose()
  @IsNumber()
  amount!: number; // 2972.61;
  @Expose()
  @IsNumber()
  amountLeft!: number; // 0;
  @Expose()
  @IsString()
  currency!: string; // "PLN";
  @Expose()
  @IsBoolean()
  exceededAmount!: boolean; // false;
}

export class DocumentsAmount {
  @Expose()
  @Type(() => NotSettledDocumentAmount)
  @ValidateNested()
  selectedDocumentAmount!: NotSettledDocumentAmount[];
  @Expose()
  @Type(() => NotSettledDocumentAmount)
  @ValidateNested()
  bankStatementAmount!: NotSettledDocumentAmount;
}
